var _circle, _circle2, _path, _path2, _path3, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryDetailsStepIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#2E77D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "#CFCFCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6949 12.7449H16.2207V14.5605H20.7242L19.1933 12.9229C19.0652 12.7662 18.8077 12.7389 18.6949 12.7449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9914 15.0586H16.2031V18.4228H16.9507C17.0931 17.693 17.5946 17.3567 18.0899 17.2836C19.1758 17.1234 19.7276 17.9719 19.8344 18.4228H20.5108C20.938 18.3659 21.0092 18.0431 20.9914 17.8888V15.0586Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47495 18.4227H10.1158C10.2439 17.7107 10.81 17.3376 11.255 17.2835C12.5722 17.1233 12.9935 17.9777 13.0706 18.4227H15.7584V11.5518C15.7157 11.1104 15.3016 11 15.0998 11H9.65295C9.11182 11.0427 8.98841 11.3857 8.99434 11.5518V17.9243C9.00858 18.323 9.32068 18.4227 9.47495 18.4227Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5747,
    cy: 18.6362,
    r: 0.979012,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3403,
    cy: 18.6362,
    r: 0.979012,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryDetailsStepIcon);
export default __webpack_public_path__ + "static/media/delivery-details-step-icon.fc772fc0678bebd80e7e843b2b4bdf0c.svg";
export { ForwardRef as ReactComponent };